import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { SearchService } from 'src/app/services/search/search.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { environment } from 'src/environments/environment';
import { CollegeDataService } from 'src/app/services/college-data.service';
import { OnlineCampaignComponent } from '../online-campaign/online-campaign.component';
import { AddInstitutionDialogComponent } from '../add-institution-dialog/add-institution-dialog.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { User } from 'src/app/model/user.model';
import * as XLSX from 'xlsx';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { ErrorStatusDialogComponent } from '../error-status-dialog/error-status-dialog.component';
import { BranchDataDTO } from 'src/app/model/branch-data-dto.model';
import { ClipboardService } from 'ngx-clipboard';
import { DownloaddatedialogComponent } from '../downloaddatedialog/downloaddatedialog.component';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';


@Component({
  selector: 'app-campaign-dashboard-v2',
  templateUrl: './campaign-dashboard-v2.component.html',
  styleUrls: ['./campaign-dashboard-v2.component.scss']
})
export class CampaignDashboardV2Component implements OnInit {

  //highlight : string = '';

  a = 5;
  selected = new FormControl();
  selectedIndex = '3';
  countData: any;
  displayCampaign = false;
  listData: any;
  campaignListData: any;
  toBeSearched: string;
  userListExcelDownload: User[] = [];
  excelDownloadData: any = [];
  error: any[];
  errorFieldArray: string[];
  errorFor: string;
  arrayBuffer: any;
  excelData: any;
  allUser: User[] = [];
  graphArray = [];
  branchDataDto: BranchDataDTO = new BranchDataDTO();
  userArray: any = [];
  branchName: any;
  sNoCount: number;
  countPercentage:number;
  fullNameCount: number;
  phoneNumberCount: number = 0;
  GenderCount: number;
  emailIdCount: number;
  qualificationCount: number;
  yearOfPassingCount: number;
  permanentCount: number;
  currentPincodeCount: number;
  currentYearCount:number;
  countReferralUsers: any;
  newCampaign: string;
  instituteType: string;

  test=[1,2,3,4,5,6,7,8,9,7]

  constructor(private campaignService: CampaignService,
              private collegeService: CollegeDataService,
              private searchService: SearchService,
              private utitlity: UtilityService,
              private excelService: ExcelService,
              private utility: UtilityService,
              private snackBarService: MatSnackBar,
              public dialog: MatDialog,
              private clipboardService: ClipboardService,
              private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    console.log("inside inti");
    this.getCount();

    
  //  console.log("tabValue:", localStorage.getItem('tabValue'));
  //  console.log("Selected value:", this.selectedIndex);
    //this.selectedIndex = '0';
    if(localStorage.getItem('index') != null)
      this.selectedIndex = localStorage.getItem('index');
    else{
      this.selectedIndex = '2';
      localStorage.setItem('index', '2');
    }
  //  console.log(this.selectedIndex)
    if (localStorage.getItem('tabValue') === null) {
      localStorage.setItem('tabValue', 'ONLINE_CAMPAIGN');



   //   console.log("ngOnit", localStorage.getItem('tabValue'));
      this.getListData('ONLINE_CAMPAIGN');
    }
    else {
      if(this.selectedIndex === '0' || this.selectedIndex === '1'){
        this.getListData(localStorage.getItem('tabValue'));
   //     console.log("fghhfbgfbgdfbhgfbghjdfbgdfbgdfbgdfb");
        
      }
     else
      this.getCampaignData(localStorage.getItem('tabValue'));
    }
  }


  getId(data) {
    this.collegeService.changeMessage(data);
  }


  // copyUrl(url) {
  //   this.clipboardService.copyFromContent(url);
  //   this.snackBarService.open('Copied to clipboard', '', { duration: 2000 
    
  // });

  // }
  selectTab(event) {
 //   console.log("Selected value:", this.selected.value);
 //   console.log("Event:", event.index);

    if (event.index === 0) {
      localStorage.setItem('tabValue', 'COLLEGE');
      localStorage.setItem('index', '0')
      this.selectedIndex = '0';
      this.getListData(localStorage.getItem('tabValue'));
    }

    else if (event.index === 1) {
      localStorage.setItem('tabValue', 'TRAINING_INSTITUTE');
      localStorage.setItem('index', '1')
      this.selectedIndex = '1';
      this.getListData(localStorage.getItem('tabValue'));
    }

    else if (event.index === 2) {
      localStorage.setItem('tabValue', 'ONLINE_CAMPAIGN');
      localStorage.setItem('index', '2')
      this.selectedIndex = '2';
      this.getCampaignData(localStorage.getItem('tabValue'));
    }

    else if (event.index === 3) {
      localStorage.setItem('tabValue', 'REFERRAL');
      localStorage.setItem('index', '3')
      this.selectedIndex = '3';
      this.getCampaignData(localStorage.getItem('tabValue'));
    }

    else if (event.index === 4) {
      localStorage.setItem('tabValue', 'OFFLINE_CAMPAIGN');
      localStorage.setItem('index', '4')
      this.selectedIndex = '4';
      this.getCampaignData(localStorage.getItem('tabValue'));
    }
    
  }

  getCount() 
  {
    this.campaignService.getCampaignDashboardCount()
      .subscribe(response => {
       
        this.countData = (response as any).data;
   //     console.log('Count:', this.countData['college']); 
      },

      error => {
  //     console.log('error after count:----->', error);
      });
     
  }

  getListData(campaignType) {
  //  console.log("Campaign type:",campaignType);
    this.displayCampaign = false;
    this.utitlity.showSpinner();
    this.campaignService.getListData(campaignType).subscribe( response => {
      
   //   console.log("Data after getting list of data:",response);
      this.listData = (response as any).data;
      this.searchService.currentMessage.subscribe(
        response => {
          this.toBeSearched = response;
    //      console.log(response);
        }
      )
      this.utitlity.hideSpinner();
    });
  }

  getCampaignData(campaignType) {
  //  console.log("campaign type: ", campaignType);
    // localStorage.setItem('selectedTab',this.selectedCampaignType);
    this.displayCampaign = true;
    this.utitlity.showSpinner();
    this.campaignService.getListData(campaignType).subscribe(
        response => {
        this.utitlity.hideSpinner();
   //     console.log("response for campaignListData", response);
        // console.log("count: ", (response as any).data[0].registeredUserIds.length);

        // this.countReferralUsers = (response as any).data[0].registeredUserIds.length
        this.campaignListData = (response as any).data;
        this.searchService.currentMessage.subscribe(
          response => {
            // console.log("to be serached: ", response);
            this.toBeSearched = response;
          })
   //     console.log("counter", this.campaignListData[1])

        for (var i = 0; i < this.campaignListData.length; i++) {
          if (this.campaignListData[i].campaignPurpose == "MCQ_TEST") {
            //this.campaignListData[i].url = environment.websiteUrl + "/?cid=" + this.campaignListData[i].id + "&type=mcq";
            this.campaignListData[i].url = environment.campaignUrl1 + "" + this.campaignListData[i].campaignShortName;
          }
          else if (this.campaignListData[i].campaignPurpose == "REGISTER_ONLY") {
            //this.campaignListData[i].url = environment.websiteUrl + "/?cid=" + this.campaignListData[i].id + "&type=reg";
            this.campaignListData[i].url = environment.campaignUrl1 + "" + this.campaignListData[i].campaignShortName;
          }
          else {
            //this.campaignListData[i].url = environment.websiteUrl + "/?cid=" + this.campaignListData[i].id + "&type=reg&refType=ref";
            this.campaignListData[i].url = environment.campaignUrl1 + "" + this.campaignListData[i].campaignShortName;
          }
        }
      });
  }

  copyUrl(url) {
    this.clipboardService.copyFromContent(url);
    this.snackBarService.open('Copied to clipboard', '', { duration: 2000 
    
  });

  }
  openAddInstitutions(): void {
    const dialogRef = this.dialog.open(AddInstitutionDialogComponent, {
      disableClose: true,
      panelClass: "dialog-style",
      // height: 'fit-content',
       width: '50em',
    });

    dialogRef.afterClosed().subscribe(result => {
   //   console.log("Result in campain-dashboard:",result);
      if (result == 'Added'){
   //     console.log("institute Type in dialog:",this.instituteType);
        
        this.getCount();
        if(localStorage.getItem('tabValue') === 'COLLEGE' || localStorage.getItem('tabValue') === 'TRAINING_INSTITUTE')
          this.getListData(localStorage.getItem('tabValue'));
      }
    });
  }

  openOnlineCampaign(): void {
    const dialogRef = this.dialog.open(OnlineCampaignComponent, {
      disableClose: true,
      panelClass: "dialog-style",
//width: '1041.33px',
      width: '57em',
      //height:'fit-Content'
    });

    dialogRef.afterClosed().subscribe(response => {
  //    console.log("Response in open online campaign:",response);
      
      if (response == "Added")
        // this.getCampaignData(this.selectedCampaignType);
        // this.ngOnInit();
        if(localStorage.getItem('tabValue') === 'ONLINE_CAMPAIGN' || localStorage.getItem('tabValue') === 'REFERRAL' || localStorage.getItem('tabValue') === 'OFFLINE_CAMPAIGN')
          this.getCampaignData(localStorage.getItem('tabValue'));
    //    console.log("New Campaign in dialog:",this.newCampaign);
        
        //this.getCampaignData(this.newCampaign);
        this.getCount();
    });
  }


  downloadHandler1(data: any,shortName) {
   console.log('download handler trigger', data.data);
  //  console.log('campaign list data', this.campaignListData);
  //  console.log('campaign data', data.registeredUserIds);

  //  console.log('institute name', data.campaignShortName);

    const fileName: any = shortName;

  //  console.log('fileName:', fileName);

    this.userListExcelDownload = data.data;

    console.log('this.userListExcelDownload', this.userListExcelDownload);

    if (data.data.length === 0) {
      const excelDownloadModel: any = new class {
        'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
        'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': '';
        'Referral Name': ''; 'Referral Contact Number': ''; 'Campaign Short Name': ''; 'College State': ''; 'Current Year': '';
        'Discipline': ''; 'College City': '';'Percentage':'';
        // 'Campaign End Date': ''; 'Campaign Url': ''; 'College Name': ''; 'College State': ''; 'Current Year': '';
        // 'Discipline': ''; 'User Key': '';
      };
      excelDownloadModel['S.NO'] = '';
      excelDownloadModel['Full Name'] = '';
      excelDownloadModel['Phone Number'] = '';
      excelDownloadModel['Gender'] = '';
      excelDownloadModel['Email id'] = '';
      excelDownloadModel['Qualification'] = '';
      excelDownloadModel['Year Of Passing'] = '';
      excelDownloadModel['Registered Date'] = '';
      excelDownloadModel['Permanent Pin Code'] = '';
      excelDownloadModel['Current Pin Code'] = '';
      excelDownloadModel['Referral Name'] = '';
      excelDownloadModel['Referral Contact Number'] = '';
      excelDownloadModel['Campaign Short Name'] = '';
      excelDownloadModel['College State'] = '';
      excelDownloadModel['Current Year'] = '';
      excelDownloadModel['Discipline'] = '';
      excelDownloadModel['College City'] = '';
      excelDownloadModel['Percentage'] = ''
      this.excelDownloadData.push(excelDownloadModel);
      this.excelService.exportAsExcelFile(this.excelDownloadData, fileName);
    } else {

      let rowNumber: number = 0;

      for (const response of this.userListExcelDownload) {
        console.log(response.currentYear+"current===========")
        const excelDownloadModel: any = new class {
          'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
          'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': '';
          'Referral Name': ''; 'Referral Contact Number': ''; 'Campaign Short Name': ''; 'Refferal Name': ''; 'Refferal Contact No': '';
          'College State': ''; 'Current Year': ''; 'Discipline': ''; 'College City': '';'Percentage':'';
        };
        excelDownloadModel['S.NO'] = ++rowNumber;
        excelDownloadModel['Full Name'] = response.fullName;
        excelDownloadModel['Phone Number'] = response.phoneNumber;
        excelDownloadModel['Gender'] = response.gender;
        excelDownloadModel['Email id'] = response.emailId;
        excelDownloadModel['Qualification'] = response.qualification;
        excelDownloadModel['Year Of Passing'] = response.graduationYear;
        excelDownloadModel['Registered Date'] = response.registeredDate;
        excelDownloadModel['Permanent Pin Code'] = response.permanentPinCode;
        excelDownloadModel['Current Pin Code'] = response.currentPinCode;
        excelDownloadModel['Referral Name'] = response.referralName;
        excelDownloadModel['Referral Contact Number'] = response.referralContactNumber;
        excelDownloadModel['Campaign Short Name'] = response.campaignShortName;
        excelDownloadModel['College State'] = response.collegeState;
        excelDownloadModel['Current Year'] = response.currentYear;
        excelDownloadModel['Discipline'] = response.discipline;
        excelDownloadModel['College City'] = response.collegeCity;
        excelDownloadModel['Percentage'] = response.percentage;
        this.excelDownloadData.push(excelDownloadModel);
      }
      this.spinnerService.hide();
      this.excelService.exportAsExcelFile(this.excelDownloadData, fileName);
    }
    this.excelDownloadData = [];
  }

  downloadHandler(data: any): void {
    console.log('Data:', data);
    let shortName = data.campaignName;
    console.log('short name--->',shortName);
    
    const dialogRef = this.dialog.open(DownloaddatedialogComponent, {
      disableClose: true,
      width: '500px',
      data: data
    });
    dialogRef.afterClosed().subscribe(dialogValue => {
      if(dialogValue!==undefined){
      this.spinnerService.show();
      console.log('The dialog was closed');
      console.log('Result:', dialogValue);
     this.campaignService.downloadDataService(dialogValue.body).subscribe(data=>{
      if(data.status==="200"){
        console.log(data);
        
        this.downloadHandler1(data,shortName);
       
      }
    });
  }
      
    });
  }


  // method to handle uploading excel data
  uploadHandler(event,data:any) {
    this.allUser = [];
    this.sNoCount = 0;
    this.fullNameCount = 0;
    this.phoneNumberCount = 0;
    this.GenderCount = 0;
    this.emailIdCount = 0;
    this.qualificationCount = 0;
    this.yearOfPassingCount = 0;
    this.permanentCount = 0;
    this.currentPincodeCount = 0;
    this.currentYearCount = 0;
    this.errorFieldArray = [];
 // console.log('id', data.id);
 //  console.log('branch', data.branchName);

    //  this.utility.showSpinner();
    const file: File = event.target.files[0];
    event.target.value = null;
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    // console.log('file',file);

    fileReader.onload = () => {

      this.arrayBuffer = fileReader.result;
      const tempData = new Uint8Array(this.arrayBuffer);
      const arr = new Array();

      for (let i = 0; i !== tempData.length; ++i) {
        arr[i] = String.fromCharCode(tempData[i]);
      }

      const bstr = arr.join('');
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const first_sheet_name = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[first_sheet_name];

      this.excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });

   //   console.log('type of excel-->', this.excelData);

      for (const value of this.excelData) {
    //    console.log('value--->', value);

        const user: User = new User();
        user.rowNumber = value['S.NO'];
        if (user.rowNumber === undefined) {
          this.sNoCount++;
        }
        user.fullName = value['Full Name'];
        if (user.fullName === undefined) {
          this.fullNameCount++;
        }
        user.phoneNumber = value['Phone Number'];

        // console.log('phnum',user.phoneNumber);
        if (user.phoneNumber === undefined) {
  //        console.log('number-->', this.phoneNumberCount);
          this.phoneNumberCount++;
        }
        user.gender = value.Gender;
        if (user.gender === undefined) {
          this.GenderCount++;
        }
        user.emailId = value['Email id'];
        if (user.emailId === undefined) {
          this.emailIdCount++;
        }
        user.qualification = value.Qualification;
        if (user.qualification === undefined) {
          this.qualificationCount++;
        }
        user.graduationYear = value['Year Of Passing'];
        if (user.graduationYear === undefined) {
          this.yearOfPassingCount++;
        }
        user.permanentPinCode = value['Permanent Pin Code'];
        if (user.permanentPinCode === undefined) {
          this.permanentCount++;
        }
        user.currentPinCode = value['Current Pin Code'];
        if (user.currentPinCode === undefined) {
          this.currentPincodeCount++;
        }
        
        user.currentYear = value['Current Year'];
        if (user.currentYear === undefined) {
          this.currentYearCount++;
        }

        if (user.percentage === undefined) {
          this.countPercentage++;
        }
        this.allUser.push(user);
      }

      if (this.phoneNumberCount === this.allUser.length) {
        // console.log('phone number column in excel sheet invalid');
        // this.snackBarService.open('phone number column in excel sheet invalid', 'close',{duration: 5000});
        this.errorFieldArray.push('Phone Number');
      }
      if (this.sNoCount === this.allUser.length) {
        this.errorFieldArray.push('sr. No');
        //  this.snackBarService.open('s.no column invalid in excel sheet', 'close', {duration: 5000});
      }
      if (this.fullNameCount === this.allUser.length) {
        this.errorFieldArray.push('Full Name');
        // this.snackBarService.open('full name column invalid in excel sheet', 'close', {duration: 5000});
      }
      if (this.GenderCount === this.allUser.length) {
        this.errorFieldArray.push('Gender');
      }
      if (this.emailIdCount === this.allUser.length) {
        this.errorFieldArray.push('Email id');
      }
      if (this.qualificationCount === this.allUser.length) {
        this.errorFieldArray.push('Qualification');
        //this.snackBarService.open('qualification column invalid in excel sheet', 'close', {duration: 5000});
      }
      if (this.yearOfPassingCount === this.allUser.length) {
        this.errorFieldArray.push('Year Of Passing');

      }
      if (this.currentYearCount === this.allUser.length) {
        this.errorFieldArray.push('Current Year');

      }

      if (this.permanentCount === this.allUser.length) {
        this.errorFieldArray.push('Permanent Pin Code');
        // this.snackBarService.open('permanent pin code column invalid in excel sheet', 'close', {duration: 5000});
      }
      if (this.currentPincodeCount === this.allUser.length) {
        this.errorFieldArray.push('Current Pin Code')
        //this.snackBarService.open('current pin code column invalid in excel sheet', 'close', {duration: 5000});
      }
     

      if (this.errorFieldArray.length != 0) {
   //     console.log('error in column-->', this.errorFieldArray);

        this.dialog.open(ErrorStatusDialogComponent, {
          width: '60%',
          data: {
            response: this.errorFieldArray,
            errorFor: 'column'
          }
        });
      }
      else {
   //     console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));

        // console.log('all user', this.allUser);
        this.branchDataDto.users = this.allUser;
       this.branchDataDto.branchId = data.id;
   //     console.log('all user', this.branchDataDto.users);
   //     console.log('got id', this.branchDataDto.branchId);
   //     console.log('excel data to upload--->', this.branchDataDto);
        this.campaignService.postExcelData(this.branchDataDto).subscribe(
          response => {
            this.utility.hideSpinner();
    //        console.log(response);
            // this.branchDataDto = null;
            this.allUser = [];
            if (response.data.validationStatus === true) {
              this.dialog.open(ErrorStatusDialogComponent, {
                width: '60%',
                data: {
                  response: response,
                  errorFor: 'row'
                }
              });
            }
            if (response.data.validationStatus === false) {
              this.snackBarService.open('excel sheet upload successfully', 'close', { duration: 4000,
                panelClass: ['snackbar']
               });
            
            }
            // this.ngOnInit();
          //  this.getBranchGraphDetail(this.id);

          }
        );
      }
    };
  }


}
